import React, { useState } from 'react'
import FavoriteImg from '../assets/images/favorites.svg'
import DummyImage from '../assets/images/dummy-image.jpg'
import FavoriteRedImg from '../assets/images/favorites-filled.svg'
import ArrowDown from '../assets/images/arrow_down.svg'
import {
  categoryAlias,
  categoryTranslations,
  parameterIcons
} from '../helpers/utils'
import ImageSwitcher from '../components/ImageSwitcher'
import { isMobile } from 'react-device-detect'
import Image from 'next/image'
import { useTranslations } from 'next-intl'
import { Link } from '@/src/navigation'
import { useLocale } from 'use-intl'
import useFavoritesStore from '../stores/favoritesStore'

const ListCard = ({ data, category }: { data: any; category: any }) => {
  const t = useTranslations('')

  const currentLanguage = useLocale()
  const [showAllIcons, setShowAllIcons] = useState(false)
  const symbols: any = {
    rub: '₽',
    amd: '֏'
  }

  const preferredPrimaryKeys: any = {
    6: ['10', '12'],
    7: ['8', '10', '11'],
    8: ['33', '22', '34'],
    9: ['11', '15', '22']
  }

  const favorites = useFavoritesStore(state => state.favorites)
  const addFavorite = useFavoritesStore(state => state.addFavorite)
  const removeFavorite = useFavoritesStore(state => state.removeFavorite)
  const isFavorite = favorites.includes(data.id)

  const handleFavoriteToggle = () => {
    if (isFavorite) {
      removeFavorite(data.id)
    } else {
      addFavorite(data.id)
    }
  }

  const showAllParameters = () => {
    setShowAllIcons(!showAllIcons)
  }

  // Split parameters into primary and secondary icons
  const allParameters = Object.entries(data.parameters)
  const primaryIcons = allParameters.filter(([key]) =>
    preferredPrimaryKeys[data.category].includes(key)
  )
  const secondaryIcons = allParameters.filter(
    ([key]) => !preferredPrimaryKeys[data.category].includes(key)
  )

  if (isMobile) {
    secondaryIcons.push(...primaryIcons) // Show all icons on mobile
  }

  return (
    <div className='estate-cart-row-item'>
      <div className='estate-cart-row-item-left'>
        <div className='' style={{ position: 'relative' }}>
          <Link
            lang={currentLanguage}
            prefetch={false}
            href={`/estate/view/${categoryAlias[data.category]}-${data.id}`}
            target='_blank'
          >
            <ImageSwitcher
              image0={data.images?.[0] || DummyImage}
              image1={data.images?.[1] || DummyImage}
              isListView={true}
            />
          </Link>
        </div>

        <div className='control-favicon' onClick={handleFavoriteToggle}>
          <Image
            src={isFavorite ? FavoriteRedImg : FavoriteImg}
            className='addTo-favorites'
            alt='heart-highlighted.svg'
            data-id='567021'
            width='24'
            height='24'
          />
        </div>
      </div>
      <div className='estate-cart-row-item-right'>
        <div className='estate-cart-row-item-title-code'>
          <div className='currencies'>
            <div className='card-price-container'>
              <p className='root_currency' id={`each-${data.id}`}>
                $ {data.price}
              </p>
              <ul
                className='other_currencies open-top'
                data-open={`each-${data.id}`}
              >
                {Object.keys(data.other_currencies).map((currency, index) => (
                  <li key={index} className='currency_item'>
                    {symbols[currency]} {data.other_currencies[currency]}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <small className='category'>
            {t(categoryTranslations[categoryAlias[data.category]])}
          </small>
        </div>
        <div className='estate-cart-row-item-address-row'>
          <p className='estate-cart-row-item-address'>{data.address}</p>
        </div>
        <div className='estate-search-list-view-description no-mobile'>
          <p className='content'>{data.description || data.code}</p>
        </div>
        <div className='estate-cart-item-footer'>
          <div
            className='estate-cart-icons no-mobile'
            style={{ padding: '10px' }}
          >
            {primaryIcons.map(([key, feature]: [string, any], index: number) => (
              <div key={index} className='estate-cart-icons-item'>
                <div className='estate-cart-single-icon'>
                  <small className='text-small'>
                    {typeof feature === 'object' && feature !== null ? (
                      <>
                        <Image src={parameterIcons[key]} alt='' />
                        <span
                          className='text-small'
                          style={{ marginLeft: '5px' }}
                        >
                          {feature.value} {key === '12' ? t('m2') : ''}
                        </span>
                      </>
                    ) : (
                      feature
                    )}
                  </small>
                </div>
                <div className='estate-cart-single-icon-hover'>
                  <small className='text-small'>
                    {typeof feature === 'object' && feature !== null
                      ? `${feature.name} ${feature.value}`
                      : feature}{' '}
                    {key === '12' ? t('m2') : ''}
                  </small>
                </div>
              </div>
            ))}

            <div
              className='estate-cart-icons-toggle no-mobile'
              onClick={showAllParameters}
            >
              <button className='toggle-button'>
                <p>{t('See all')}</p>
                <Image src={ArrowDown} alt='icon' />
              </button>
            </div>
          </div>

          <div
            className='estate-cart-icons-toggle-mobile mobile'
            onClick={showAllParameters}
          >
            <small className='toggle-button'>
              {t('See all')} <Image src={ArrowDown} alt='icon' />
            </small>
          </div>

          {showAllIcons && (
            <div className='estate-cart-icons-row'>
              {secondaryIcons.map(([key, feature]: [string, any], index: number) => (
                <div key={index} className='estate-cart-icons-item'>
                  <div className='estate-cart-single-icon'>
                    <small className='text-small'>
                      {typeof feature === 'object' && feature !== null ? (
                        <>
                          <Image src={parameterIcons[key]} alt='' />
                          <span
                            className='text-small'
                            style={{ marginLeft: '5px' }}
                          >
                            {feature.value}
                          </span>
                        </>
                      ) : (
                        feature
                      )}
                    </small>
                  </div>
                  <div className='estate-cart-single-icon-hover'>
                    <small className='text-small'>
                      {typeof feature === 'object' && feature !== null
                        ? `${feature.name} ${feature.value}`
                        : feature}
                    </small>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ListCard
